// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"14ed947a","217":"8f5859e8","379":"d0f8160c","388":"bf330eb5","448":"922216ad","484":"526e665e","708":"04510f1c","714":"b35a79aa","893":"6acbd903","934":"a9e758f2"}[chunkId] + ".chunk.js";
};